export const NEW_SYSTEM_BASE_PATH = 'metis'
export const OLD_SYSTEM_HOST =
  process.env.NODE_ENV === 'development' ? '//localhost:8080' : ''
export const ACCOUNT_VERSION = {
  SUPERTEST_VERSION: 0, // 超级版-测试专用
  MARKETING_VERSION: 1, // 营销版
  FLAGSHIP_VERSION: 2, // 旗舰版
  NET_WORKS_VERSION: 3, // 网络门店
  TASTE_VERSION: 5, // 尝鲜版本
  JOIN_IN_VERSION: 6, // 渠道版
  FRANCHISE_VERSION: 8, // 加盟版
  FYLM_VERSION: 9 // 房源联卖版本
}
